import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import { createMarkup } from "../../helpers";

const EditorIndex = ({ editorRef, label, reqd, value = "", get }) => {
  return (
    <div>
      <label
        htmlFor={""}
        className="control-label"
        style={{ marginBottom: "10px" }}
      >
        <span dangerouslySetInnerHTML={createMarkup(label)} />{" "}
        {reqd && <span className="reqd">*</span>}
      </label>

      <Editor
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={value}
        apiKey="zrv4of3y9mwtph1ev39bi1zhmk8ctqvg0nhisy294k0dz9d3"
        init={{
          relative_urls: false,
          remove_script_host: false,
          document_base_url: "https://valerotexasopen.com/",
          paste_as_text: true,
          height: 500,
          menubar: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help wordcount",
          ],
          toolbar:
            "undo redo | formatselect | " +
            "bold italic forecolor backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "link image | " +
            "removeformat | help",
          content_style:
            "body {border:none;background-color:#fff;margin:0;padding:15px;font-family:Arial,Helvetica,sans-serif;font-size:14px;}" +
            "img {max-width:100%;height:auto;}",
        }}
      />
    </div>
  );
};

export default EditorIndex;
